<template>
    <v-fade-transition>
        <v-overlay v-show="loading" color="white">
            <v-progress-circular size="100" width="5" color="primary" indeterminate />
        </v-overlay>
    </v-fade-transition>
</template>

<script>
export default {
    props: {
        loading: { type: Boolean, default: false },
    },
};
</script>

<style></style>
